import { render, staticRenderFns } from "./layout-base.vue?vue&type=template&id=4fb1cf30&"
import script from "./layout-base.vue?vue&type=script&lang=js&"
export * from "./layout-base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\YrtDev\\wms\\wms-site\\main\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fb1cf30')) {
      api.createRecord('4fb1cf30', component.options)
    } else {
      api.reload('4fb1cf30', component.options)
    }
    module.hot.accept("./layout-base.vue?vue&type=template&id=4fb1cf30&", function () {
      api.rerender('4fb1cf30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/layout-base.vue"
export default component.exports